import { Info } from 'lucide-react'

export const PhoneInfo = () => {
  return (
    <div className="flex flex-row w-full max-w-100 rounded-lg bg-[#EBF4FF] pt-3 pb-6 pl-3 pr-8 gap-2">
      <Info className="w-4 h-4 text-[#3D3D3D] shrink-0 mt-1" />
      <div className="flex flex-col">
        <h3 className="text-base font-bold text-primary">
          Prečo potrebujeme telefónne číslo?
        </h3>
        <p className="text-sm font-medium text-primary">
          Telefónne číslo použijeme hlavne na elektronický podpis zmlúv. Môže
          vás naň kontaktovať náš zákaznícky servis. Ak si to neželáte, stačí
          nám po overení čísla dať vedieť a nebudeme vás ďalej kontaktovať.
        </p>
      </div>
    </div>
  )
}
